import store from '@/store';
import {SiteId} from '@/enums';

export function isVariationMunicipality(): boolean {
	const siteId = store.getters.getSiteType;

	return siteId === SiteId.MUNICIPALITY;
}

export function isVariationDiet(): boolean {
	const siteId = store.getters.getSiteType;

	return siteId === SiteId.ALL_ABOUT_DIET;
}
